import { render, staticRenderFns } from "./PresentationChat.vue?vue&type=template&id=a73c2194&scoped=true&"
import script from "./PresentationChat.vue?vue&type=script&lang=js&"
export * from "./PresentationChat.vue?vue&type=script&lang=js&"
import style0 from "./PresentationChat.vue?vue&type=style&index=0&id=a73c2194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73c2194",
  null
  
)

export default component.exports